import { Color, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

interface AccountFromTemplateModalHeadingProps {
  subtitle: string
  title: string
}

export const AccountFromTemplateModalHeading = ({
  subtitle,
  title,
}: AccountFromTemplateModalHeadingProps): ReactElement => (
  <Flex flexDirection="column" gap={Spacing.S2}>
    <Text variant="h3">{title}</Text>
    <Text color={Color.Grey800} variant="bodyMD">
      {subtitle}
    </Text>
  </Flex>
)
